export enum ConfigLayerLoaderType {
  GEOJSON = 'geojson'
}
